export enum ScreenMode {
  STATIC,
  DYNAMIC,
  ORDERS_BASKET,
}
